import React, {Component} from 'react';
import common from "../common";

class GeneralPopUp extends Component {
    timeout = null;

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    componentWillReceiveProps(nextProps) {
        const {showPopup, resetToast} = nextProps;
        if (showPopup && resetToast) {
            this.timeout = setTimeout(() => {
                let bodyElem = document.body;
                bodyElem.classList.remove('bodyNoScroll');
                resetToast();
            }, 3000);
        }
    }

    componentDidMount() {
        const {showPopup, resetToast} = this.props;
        if (showPopup && resetToast) {
            this.timeout = setTimeout(() => {
                let bodyElem = document.body;
                bodyElem.classList.remove('bodyNoScroll');
                resetToast();
            }, 3000);
        }
    }

    render() {
        const {showPopup, message, title, wrapperClass, secondaryBtnText, primaryBtnText, secondaryBtnHandler, primaryBtnHandler, iconClass, isToast} = this.props;
        const secondaryBtnClick = secondaryBtnHandler ? {onClick: () => secondaryBtnHandler()} : {};
        const primaryBtnClick = primaryBtnHandler ? {onClick: () => primaryBtnHandler()} : {};
        const classObj = {
            'si-common-popup': true,
            'si-small-popup' : !isToast,
        };
        const modalClass = common.makeClasses({
            'si-modal-wrap'  : !isToast,
            'si-common-toast': isToast
        });
        wrapperClass && (classObj[wrapperClass] = true);
        const wrapperClasses = common.makeClasses(classObj);
        return showPopup ? <div className={modalClass}>
            <div className={wrapperClasses}>
                <div className="si-popup-body si-flexBox">
                    {iconClass ? <div className="si-logo-wrap">
                        <i className={iconClass}/>
                    </div> : null}
                    <div className="si-details-wrap">
                        {title ? <div className="si-title">{title}</div> : null}
                        {message ? <div className="si-more-info">
                            <span>{message}</span>
                        </div> : null}
                    </div>
                </div>
                {(secondaryBtnText || primaryBtnText) ? <div className="si-popup-btn-wrap si-league-btn">
                    {primaryBtnText ? <div className="si-btn si-btn-primary"{...primaryBtnClick}>
                        <span>{primaryBtnText}</span>
                    </div> : null}
                    {secondaryBtnText ? <div className="si-btn si-btn-secondary-wb" {...secondaryBtnClick}>
                        <span>{secondaryBtnText}</span>
                    </div> : null}
                </div> : null}
            </div>
        </div> : null;
    }
}

export default GeneralPopUp;


// WEBPACK FOOTER //
// ./src/components/GeneralPopUp.js